import { IDependentValue } from "@publishing-engine/domain/models";
import { DisplayField } from "src/components/shared/DisplayField";

export const MissingReference = ({ config, missingReference }: {
	config: any;
	missingReference: IDependentValue<string> | null;
}) => {
	if (!config || !missingReference) return null;

	const adaptedConfig = { MissingReference: config };
	return (
		<DisplayField
			fieldName="MissingReference"
			value={missingReference}
			config={adaptedConfig}
		/>
	);
}